var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{staticClass:"donutComercial",attrs:{"type":"donut","series":_vm.series,"options":_vm.chartOptions,"height":_vm.height,"width":'300px'}})}
var staticRenderFns = []

export { render, staticRenderFns }